import React from 'react';
import Gallery from '../components/Gallery';

const GalleryPage = () => {
    return <Gallery />;
};

export default GalleryPage;